module.exports = __webpack_public_path__ + "static/media/token.59479078.png";